import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  text = 'Wird geladen...', 
  className = '' 
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-8 h-8'
  };

  const textSizeClasses = {
    small: 'text-xs',
    medium: 'text-sm',
    large: 'text-base'
  };

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center p-4 ${className}`}>
      {/* Spinner Animation - WEDL Colors - Klein & Kompakt */}
      <div className={`${sizeClasses[size]} mb-2 relative`}>
        <div className="absolute inset-0 border-2 border-gray-300 rounded-full"></div>
        <div className="absolute inset-0 border-2 border-red-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
      
      {/* Loading Text - Klein & Kompakt */}
      <p className={`${textSizeClasses[size]} text-gray-700 font-medium text-center`}>
        {text}
      </p>
    </div>
  );
};

export default LoadingSpinner;